import React from 'react';
import { formatPrice } from '../../utils/money';
import Abbr from '../../shared/Abbr';

const columns = [
    {
        key: 'saleYear',
        header: 'horse',
        cell: ({ type, saleYear }) => (type === 'total' ? saleYear : `${saleYear} ${type}`),
    },
    {
        key: 'byersCount',
        header: () => <Abbr title="catalogued" breakpoint="fromMedium">cat&apos;d</Abbr>,
    },
    {
        key: 'offeredCount',
        header: () => <Abbr title="offered" breakpoint="fromMedium">off&apos;d</Abbr>,
    },
    {
        key: 'salesCount',
        header: 'sold (%)',
        cell: ({ salesCount, soldPercent }) => `${salesCount} (${soldPercent || ''}%)`,
    },
    {
        key: 'priceAverage',
        header: 'average',
        cell: ({ priceAverage }) => formatPrice(priceAverage),
    },
    {
        key: 'priceMax',
        header: 'highest',
        cell: ({ priceMax }) => formatPrice(priceMax),
    },
    {
        key: 'median',
        cell: ({ median }) => formatPrice(median),
    },
    {
        key: 'priceMin',
        header: 'low',
        cell: ({ priceMin }) => formatPrice(priceMin),
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/horse/salesStatistics/columns.jsx